// import React from 'react';
// import { Button, Card, Col, Container, Row } from 'react-bootstrap';
// import { Link, useNavigate } from 'react-router-dom';
// import Main from './Main.jsx';
// import AboutUs from './About.jsx';
// import NewsAbout from './NewsAbout.jsx';
// import QuickCards from './QuickCards.jsx';

// // Custom styles for hover effects and responsive design
// const styles = `
//   .howtolink {
//     color: #666;
//     text-decoration: none;
//     transition: all 0.2s ease;

//   }
  
//   .howtolink:hover {
//     text-decoration: underline !important;
//   }
  
//   .hoverviewmore:hover {
//     opacity: 0.9;
//   }
  
//   .service-card {
//     transition: all 0.3s ease;
//   }
  
//   .links-container {
//     display: flex;
//     flex-wrap: wrap;
//     align-items: center;
//   }
  
//   .link-divider {
//     display: inline-block;
//   }
  
//   @media (max-width: 768px) {
//     .card-header-flex {
//       flex-direction: column;
//       align-items: flex-start !important;
//     }
//     }
  
//   @media (max-width: 576px) {
//     .link-divider {
//       display: none;
//     }
//     .card-body {
//     padding-bottom: 0rem !important;
//     position: relative;
//     display: flex;
//     flex-direction: column;
//     min-height: 150px;
// }
//     .howtolink {
//     font-size: 14px !important; 
//   }


//     .links-container {
//       flex-direction: column;
//       align-items: flex-start;
//     }
    
//     .howtolink {
//       padding: 0.15rem 0;
//     }
//   }
// `;

// const Home = () => {
//   const navigate = useNavigate();
  
//   return (
//     <>
//       <style>{styles}</style>
//       <div>
//         <Main />
        
//         <section className="services-section py-3">
//           <Container fluid="md">
//             <Row className="g-4">
//               <Col xs={12} className="px-3">
//                 <Card className="service-card shadow-sm">
//                   <Card.Body className="p-3 p-md-4">
//                     <div className="d-flex align-items-center mb-0 card-header-flex">
//                       <div className="card-title-container">
//                         <Card.Title as="h3" className="mb-0 me-3 fs-4 fw-semibold">
//                           How To ?
//                         </Card.Title>
//                       </div>
                      
//                       <div className="links-container">
//                         <Link to="/setup-vpn" className="howtolink fs-6">
//                           Setup VPN
//                         </Link>
                        
//                         <span className="mx-1 link-divider">|</span>
                        
//                         <Link to="/iitd-proxy" className="howtolink fs-6">
//                           Setup IITD Proxy
//                         </Link>
                        
//                         <span className="mx-1 link-divider">|</span>
                        
//                         <Link to="/book-csc-lab" className="howtolink fs-6">
//                           Book CSC lab
//                         </Link>
                        
//                         <span className="mx-1 link-divider">|</span>
                        
//                         <a
//                           href="https://userm.iitd.ac.in/usermanage/pwchange.html"
//                           className="howtolink fs-6"
//                           target="_blank"
//                           rel="noopener noreferrer"
//                         >
//                           Change kerberos password
//                         </a>
//                            <span className="mx-1 link-divider">|</span>
//                         <Link to="/services-user-admin-infra-internet-access-visitor" className="howtolink fs-6">
//                           Get Visitor Internet Access
//                         </Link>
                        
//                         <span className="mx-1 link-divider">|</span>
//                       </div>
//                     </div>
                    
//                     <div className="d-flex justify-content-start mt-2">
//                       <Button
//                         variant="danger"
//                         size="sm"
//                         className="hoverviewmore"
//                         style={{
//                           backgroundColor: "#c21717",
//                           border: "none"
//                         }}
//                         onClick={() => navigate('/howto')}
//                       >
//                         View More
//                       </Button>
//                     </div>
//                   </Card.Body>
//                 </Card>
//               </Col>
//             </Row>
//           </Container>
          
//           <QuickCards />
//         </section>
        
//         <AboutUs />
//         <NewsAbout />
//       </div>
//     </>
//   );
// };

// export default Home;


import React from 'react';
import { Button, Card, Col, Container, Row } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import Main from './Main.jsx';
import AboutUs from './About.jsx';
import NewsAbout from './NewsAbout.jsx';
import QuickCards from './QuickCards.jsx';
import QuickContacts from './QuickContacts.jsx';

// Custom styles for hover effects and responsive design
const styles = `
  .howtolink {
    color: #666;
    text-decoration: none;
    transition: all 0.2s ease;
  }
  
  .howtolink:hover {
    text-decoration: underline !important;
  }
  
  .hoverviewmore:hover {
    opacity: 0.9;
  }
  
  .service-card {
    transition: all 0.3s ease;
  }
  
  .links-container {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }
  
  .link-divider {
    display: inline-block;
  }
  
  @media (max-width: 768px) {
    .card-header-flex {
      flex-direction: column;
      align-items: flex-start !important;
    }
  }
  
  @media (max-width: 576px) {
    .link-divider {
      display: none;
    }
    .card-body {
      padding-bottom: 0rem !important;
      position: relative;
      display: flex;
      flex-direction: column;
      min-height: 150px;
    }
    .howtolink {
      font-size: 14px !important; 
    }
    .links-container {
      flex-direction: column;
      align-items: flex-start;
    }
    .howtolink {
      padding: 0.15rem 0;
    }
  }
`;

const Home = () => {
  const navigate = useNavigate();
  
  return (
    <>
      <style>{styles}</style>
      <div>
        <Main />
        
        <section className="services-section py-5">
          <Container fluid="md">
            <Row className="g-4">
              {/* How To Section */}
              <Col xs={12} lg={6} className="px-3">
                <Card className="service-card shadow-sm">
                  <Card.Body className="p-3">
                    <div className="d-flex align-items-center mb-0 card-header-flex">
                      <div className="card-title-container">
                        <Card.Title as="h3" className="mb-0 me-3 fs-4 fw-semibold">
                          How To?
                        </Card.Title>
                      </div>
                      
                      <div className="links-container">
                        <Link to="/setup-vpn" className="howtolink fs-6">
                          Setup VPN
                        </Link>
                        
                        <span className="mx-1 link-divider">|</span>
                        
                        <Link to="/iitd-proxy" className="howtolink fs-6">
                          Setup IITD Proxy
                        </Link>
                        
                        <span className="mx-1 link-divider">|</span>
                        
                        <Link to="/book-csc-lab" className="howtolink fs-6">
                          Book CSC Lab
                        </Link>
                        
                        <span className="mx-1 link-divider">|</span>
                        
                        <a
                          href="https://userm.iitd.ac.in/usermanage/pwchange.html"
                          className="howtolink fs-6"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Change Kerberos Password
                        </a>
                        
                        <span className="mx-1 link-divider">|</span>
                        
                        <Link to="/services-user-admin-infra-internet-access-visitor" className="howtolink fs-6">
                          Get Visitor Internet Access
                        </Link>
                        
                        <span className="mx-1 link-divider">|</span>
                      </div>
                    </div>
                    
                    <div className="d-flex justify-content-start mt-2">
                      <Button
                        variant="danger"
                        size="sm"
                        className="hoverviewmore"
                        style={{
                          backgroundColor: "#c21717",
                          border: "none"
                        }}
                        onClick={() => navigate('/howto')}
                      >
                        View More
                      </Button>
                    </div>
                  </Card.Body>
                </Card>
              </Col>

              {/* Quick Contacts Section */}
              <Col xs={12} lg={6} className="px-3">
                <QuickContacts />
              </Col>
            </Row>
          </Container>
          
          <QuickCards />
        </section>
        
        <AboutUs />
        <NewsAbout />
      </div>
    </>
  );
};

export default Home;

// old home code 
// import React from 'react'
// import Main from './Main.jsx';
// import AboutUs from './About.jsx';
// import NewsAbout from './NewsAbout.jsx';
// import QuickCards from './QuickCards.jsx';
// import { Card, Col, Container, Row } from 'react-bootstrap';
// import { Link } from 'react-router-dom';
// // import SecondMain from './SecondMain.jsx';
// // import ThirdMain from './ThirdMain.jsx';
// // import FourthMain from './FourthMain.jsx';
// // import Fifthmain from './Fifthmain.jsx';

// const Home = () => {
//   return (
//     <div>
//       <Main />
//       <div className="services-section">
//         <Container>
//           <Row className="g-4">
//             {/* Networking Card */}
//             <Col md={12}>
//               <Card className="service-card service-card card">
//                 <Card.Body className="p-4">
//                   <Card.Title as="h3" className="h4 mb-3">
//                     How To
//                   </Card.Title>
//                   <Card.Text className="text-muted">
//                   <Link to="/setup-vpn" className='howtolink' style={{color:"#212529bf",textDecoration:"none"}}>
//                   Setup VPN
//                   </Link> |  <Link to="/iitd-proxy" className='howtolink' style={{color:"#212529bf",textDecoration:"none"}}>
//                   Setup IITD Proxy
//                   </Link> 
//                   </Card.Text>
//                 </Card.Body>
//               </Card>
//             </Col>
//           </Row>
//         </Container>
//       </div>
//       <AboutUs />
//       <NewsAbout />
//       <QuickCards />
//       {/* <SecondMain /> */}
//       {/* <div id="aboutus">
//       <ThirdMain />
//                     </div>
     
//       <FourthMain />
//       <Fifthmain /> */}
//     </div>
//   )
// }

// export default Home